import AlertsCard from "./AlertsCard";
export default AlertsCard;
